import apiClient from './client';

export const PayerAxiosInstance = apiClient;